import '.a{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.an{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ao{max-width:77.5rem;}.ssr-plugin'
import '.fh{justify-content:stretch;}.ssr-plugin'
import '.ba{position:sticky;}.ssr-plugin'
import '.bb{top:0px;}.ssr-plugin'
import '.bf{z-index:10;}.ssr-plugin'
import '.fi{padding-block:1rem;}.ssr-plugin'
import '.fj{height:3rem;}.ssr-plugin'
import '.at{justify-content:space-between;}.ssr-plugin'
import '.aw{flex-wrap:wrap;}.ssr-plugin'
import '.fk{margin-bottom:0px;}.ssr-plugin'
import '.fl{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ef{margin-top:2rem;}.ssr-plugin'
import '.fm{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="a a2 ab b e2"
      >
        <div className="an a r ab b"
        >
          <div className="ao a b fh ba bb bf e2"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fi fj a at r aw"
            >
              <styled.span className="fk"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fl a b a2 ef fm ao"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
